<template>
    <VListItemActionText v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VListItemActionText>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item-action-text';

export default {
    name: 'SrListItemActionText',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
